<div class="item-media collapsed-padding" *ngIf="avatarInfo">
    <div class="sidebar-v2-circle sidebar-v2-circle--initials">
        <img *ngIf="avatarInfo.avatar; else userInitial" [src]="avatarInfo.avatar" />
        <ng-template #userInitial>
            <span>{{ initial }}</span>
        </ng-template>
    </div>
</div>
